import { RouteMapping } from './route-mapping.js';
export var SkillsetRouteRule;
(function (SkillsetRouteRule) {
    SkillsetRouteRule["AuthRoute"] = "AuthRoute";
    SkillsetRouteRule["ProtectedRoute"] = "ProtectedRoute";
    SkillsetRouteRule["AllowedWithUploadedJst"] = "AllowedWithUploadedJst";
})(SkillsetRouteRule || (SkillsetRouteRule = {}));
const skillSetRoutes = {
    HomePage: {
        path: '/',
        pageName: 'HomePage',
        component: 'HomeScreen',
        isHeaderHidden: false,
        protectedRoute: true,
        isAuthRoute: true,
        isAuth0CallbackRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {
            Checklist: {
                path: 'checklist',
                routeName: 'Checklist',
                component: 'ChecklistScreen'
            },
            CareerExploration: {
                path: 'career-exploration',
                routeName: 'CareerExploration',
                component: 'CareerExplorationScreen'
            }
        },
        redirectRules(user) {
            return [
                {
                    name: SkillsetRouteRule.ProtectedRoute,
                    isRenderAllowed: !!user
                },
                {
                    name: SkillsetRouteRule.AllowedWithUploadedJst,
                    redirectTo: skillSetRoutes.WelcomePage.pageName,
                    isRenderAllowed: !!user?.jst
                }
            ];
        }
    },
    AuthCallbackPage: {
        path: '/auth-callback',
        pageName: 'AuthCallbackPage',
        component: 'AuthCallbackScreen',
        isHeaderHidden: true,
        protectedRoute: false,
        isAuthRoute: true,
        isAuth0CallbackRoute: false,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    SignupPage: {
        path: '/signup',
        pageName: 'SignupPage',
        component: 'SignupScreen',
        isHeaderHidden: true,
        protectedRoute: false,
        isAuthRoute: true,
        isAuth0CallbackRoute: false,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules(user) {
            return [
                {
                    name: SkillsetRouteRule.AuthRoute,
                    isRenderAllowed: !user,
                    redirectTo: skillSetRoutes.HomePage.pageName
                }
            ];
        }
    },
    SignupConfirmationPage: {
        path: '/signup-confirmation',
        pageName: 'SignupConfirmationPage',
        component: 'SignupConfirmationScreen',
        isHeaderHidden: true,
        protectedRoute: false,
        isAuthRoute: true,
        isAuth0CallbackRoute: false,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules(user) {
            return [
                {
                    name: SkillsetRouteRule.AuthRoute,
                    isRenderAllowed: !user,
                    redirectTo: skillSetRoutes.HomePage.pageName
                }
            ];
        }
    },
    WelcomePage: {
        path: '/welcome',
        pageName: 'WelcomePage',
        component: 'WelcomeScreen',
        isHeaderHidden: false,
        protectedRoute: true,
        isAuthRoute: false,
        isAuth0CallbackRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules(user) {
            return [
                {
                    name: SkillsetRouteRule.ProtectedRoute,
                    isRenderAllowed: !!user
                },
                {
                    name: SkillsetRouteRule.AllowedWithUploadedJst,
                    isRenderAllowed: !user?.jst,
                    redirectTo: skillSetRoutes.HomePage.pageName
                }
            ];
        }
    },
    ProfilePage: {
        path: '/profile',
        pageName: 'ProfilePage',
        component: 'ProfileScreen',
        isHeaderHidden: false,
        protectedRoute: true,
        isAuthRoute: true,
        isAuth0CallbackRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: ['section'],
        nestedRoutes: {},
        redirectRules(user) {
            return [
                {
                    name: SkillsetRouteRule.ProtectedRoute,
                    isRenderAllowed: !!user
                }
            ];
        }
    },
    LearningRecommendationsPage: {
        path: '/learning-recommendations',
        pageName: 'LearningRecommendationsPage',
        component: 'LearningRecommendationsScreen',
        isHeaderHidden: false,
        protectedRoute: true,
        isAuthRoute: true,
        isAuth0CallbackRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [
            'jobRoleIds',
            'locationIds',
            'awardLevelIds',
            'benefitIds',
            'credentialTypeIds',
            'deliveryMethodIds',
            'price',
            'duration'
        ],
        nestedRoutes: {},
        redirectRules(user) {
            return [
                {
                    name: SkillsetRouteRule.ProtectedRoute,
                    isRenderAllowed: !!user
                },
                {
                    name: SkillsetRouteRule.AllowedWithUploadedJst,
                    redirectTo: skillSetRoutes.WelcomePage.pageName,
                    isRenderAllowed: !!user?.jst
                }
            ];
        }
    },
    LearningRecommendationPage: {
        path: '/learning-recommendations/:id',
        pageName: 'LearningRecommendationPage',
        component: 'LearningRecommendationScreen',
        isHeaderHidden: false,
        protectedRoute: true,
        isAuthRoute: true,
        isAuth0CallbackRoute: true,
        authorizedFor: [],
        pathParams: ['id'],
        queryParams: [
            'jobRoleIds',
            'locationIds',
            'awardLevelIds',
            'benefitIds',
            'credentialTypeIds',
            'deliveryMethodIds',
            'price',
            'duration'
        ],
        nestedRoutes: {},
        redirectRules(user) {
            return [
                {
                    name: SkillsetRouteRule.ProtectedRoute,
                    isRenderAllowed: !!user
                },
                {
                    name: SkillsetRouteRule.AllowedWithUploadedJst,
                    redirectTo: skillSetRoutes.WelcomePage.pageName,
                    isRenderAllowed: !!user?.jst
                }
            ];
        }
    }
};
export class SkillSetRouteMapping extends RouteMapping {
    constructor() {
        super(skillSetRoutes);
    }
}
//# sourceMappingURL=skillset.js.map